// extracted by mini-css-extract-plugin
export default {"container":"ContracteumLogo_container__X8+5r","textLogoDashboard":"ContracteumLogo_textLogoDashboard__Qgi3U","textLogoAuth":"ContracteumLogo_textLogoAuth__RNw7i"};